module.exports = __webpack_public_path__ + "static/manish-8af6c61dbce38ef9073e1de4e79b60d5.png";